<template>
  <div class="receivingAddress">
    <div class="personal-box comWidth">
      <CenterNav/>
      <div class="personal-right">
        <NavT :titleS="titleS"/>
        <div class="rightmain">
          <el-table :data="addressData" style="width: 100%">
            <el-table-column prop="consignee" label="收貨人" width="180"></el-table-column>
            <el-table-column label="收貨地址" width="180">
              <template slot-scope="scope">
                {{scope.row.province}}
                {{scope.row.city}}
                {{scope.row.district}}
                {{scope.row.address}}
              </template>
            </el-table-column>
            <el-table-column prop="tel" label="聯系電話" width="180"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="handleEdit(scope.row)">修改</el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="deleteData(scope.row)">删除</el-button>
                <a v-if="scope.row.is_default == 0"
                  class="default-btnS"
                           size="mini"
                           @click="defaultAddress(scope.row)" >默認地址</a>
                <a v-if="scope.row.is_default == 1"
                  class="default-btn"
                           size="mini">默認地址</a>
              </template>
            </el-table-column>
          </el-table>

          <div class="bottomS">
            <NavTs :titleS="titleSt"/>

            <form>
          <!--    <div class="formGoup">
                <label><span>*</span>所在国家</label>
                <select @change="countryChange" v-model="form.country" class="control">
                  <option value="中國">中國</option>
                  <option value="其他">其他</option>
                </select>
              </div>-->

              <div class="formGoup" v-if="countryState">
                <label><span>*</span>所在地區</label>
                <div id="app">
                  <el-cascader
                    size="large"
                    :options="options"
                    v-model="selectedOptions"
                    @change="handleChange">
                  </el-cascader>
                </div>
              </div>

              <div class="formGoup">
                <label><span>*</span>詳細地址</label>
                <textarea v-model="form.address"  class="form-control control"  rows="3"></textarea>
              </div>

              <div class="formGoup">
                <label><span>*</span>收貨人</label>
                <input v-model="form.consignee" type="text" class="control" placeholder="請輸入收件人姓名">
              </div>

              <div class="formGoup">
                <label><span>*</span>手機號碼</label>
                <input v-model="form.tel " type="tel" class="control" maxlength="11"  placeholder="請輸入手機號碼">
              </div>

         <!--     <div class="formGoup">
                <label><span></span>電話號碼</label>
                <input v-model="form.mobile" type="mobile" class="control"   placeholder="請輸入電話號碼">
              </div>

              <div class="formGoup">
                <label><span></span>郵箱</label>
                <input v-model="form.zip_code" type="email" class="control"   placeholder="請輸入郵箱">
              </div>-->

              <!--<div class="defut">{{form.radio}}-->
                <!--<label><span></span>是否设置为默认地址</label>-->
                <!--<el-radio v-model="form.is_default" label="1">是</el-radio>-->
                <!--<el-radio v-model="form.is_default" label="0">否</el-radio>-->
              <!--</div>-->

              <div class="formGoup">
                <button @click="confirmAddition" type="button" class="btn">確認添加</button>
              </div>

            </form>

          </div>
        </div>
      </div>
    </div>

    <el-dialog title="修改收貨地址" :visible.sync="dialogFormVisible" :lockScroll="false">
    <el-form :label-width="formLabelWidth" :model="modifyData">
 <!--   <el-form-item label="所在国家" required>
    <el-select v-model="modifyData.country" placeholder="请选择活动区域">
    <el-option label="中國" value="中國"></el-option>
    <el-option label="其他" value="其他"></el-option>
    </el-select>
    </el-form-item>-->
    <el-form-item label="所在地區"  required>
    <el-cascader
    size="large"
    :options="optionsX"
    v-model="selectedOptionsX"
    @change="handleChangeX">
    </el-cascader>
    </el-form-item>

    <el-form-item label="詳細地址"  required>
    <el-input v-model="modifyData.address" auto-complete="off"></el-input>
    </el-form-item>

    <el-form-item label="收貨人" :label-width="formLabelWidth" required>
    <el-input v-model="modifyData.consignee" auto-complete="off"></el-input>
    </el-form-item>

    <el-form-item label="手機號碼" :label-width="formLabelWidth" required>
    <el-input v-model="modifyData.tel" auto-complete="off"></el-input>
    </el-form-item>

<!--    <el-form-item label="電話號碼" :label-width="formLabelWidth">
    <el-input v-model="modifyData.mobile" auto-complete="off"></el-input>
    </el-form-item>

    <el-form-item label="郵箱" :label-width="formLabelWidth">
    <el-input v-model="modifyData.zip_code" auto-complete="off"></el-input>
    </el-form-item>-->

    </el-form>
    <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="modify">確認修改</el-button>
    </div>
    </el-dialog>
  </div>
</template>

<script>
  //nav
  import NavT from '@/pages/personalPage/NavT'
  import NavTs from '@/pages/personalPage/NavT'
  import NavTsx from '@/pages/personalPage/NavT'
  //cNav
  import CenterNav from '@/pages/personalPage/CenterNav'
  //adress
  import { regionData , CodeToText ,TextToCode} from 'element-china-area-data'
  //api
  import {addAddress , modifyAddress , deleteAddress , obtainAddress} from '@/api/address';
  import {getToken} from '@/utils/auts';
  import { Loading } from 'element-ui';
  export default {
    name: 'ReceivingAddress',
    components:{
      NavT,
      NavTs,
      NavTsx,
      CenterNav
    },
    data () {
      return {
          form: {
//            country:'',//国家
            province:'',//省份
            city:'',//城市
            district:'',//区/县
            address:'',//详细地址
            consignee:'',//收货人
            tel:'',//手机号码
//            mobile:'',//电话号码
//            zip_code:'',//邮箱
            is_default: 0,//是否设为默认地址
          },

        titleS:'收貨地址',
        titleSt:'新增收貨地址',
        titleSx:'修改收貨地址',
        /*地址选择*/
        options: regionData,
        selectedOptions: [],
        optionsX: regionData,
        selectedOptionsX: [],
        /*新增地址信息*/
        telRg:/^1[3,4,5,6,7,8,9]\d{9}$/,
        emailRg: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
        countryState: true,//显示国家

        /*收货地址数据显示*/
        addressData:[],
        modifyData:{
//          country:'',//国家
          province:'',//省份
          city:'',//城市
          district:'',//区/县
          address:'',//详细地址
          consignee:'',//收货人
          tel:'',//手机号码
//          mobile:'',//电话号码
//          zip_code:'',//邮箱
          is_default: '',//是否设为默认地址
        },

        dialogTableVisible: false,
        dialogFormVisible: false,
        formLabelWidth: '120px',

      }
    },
    methods:{
      /*修改地址*/
      handleEdit(item) {
        this.dialogFormVisible = true;
        this.selectedOptionsX = [item.province ? TextToCode[item.province].code : undefined, item.city ? TextToCode[item.province][item.city].code: undefined, item.district ? TextToCode[item.province][item.city][item.district].code : undefined]

          this.modifyData = {
//            country:item.country,//国家
            province:item.province,//省份
            city:item.city,//城市
            district:item.district,//区/县
            address:item.address,//详细地址
            consignee:item.consignee,//收货人
            tel:item.tel,//手机号码
//            mobile:item.mobile,//电话号码
//            zip_code:item.zip_code,//邮箱
            is_default: item.is_default,//是
            id: item.id,//id
          };
      },


      /*确认修改地址*/
      modify(item){
        this.verificationMsg(this.modifyData,modifyAddress,this.selectedOptionsX);
      },

        //区域选择
      handleChange (value) {
        this.form.province = CodeToText[value[0]];
        this.form.city = CodeToText[value[1]];
        this.form.district = CodeToText[value[2]];
      },
      handleChangeX (value) {
        this.modifyData.province = CodeToText[value[0]];
        this.modifyData.city = CodeToText[value[1]];
        this.modifyData.district = CodeToText[value[2]];
      },

      /*判断国家*/
      countryChange(){
          if(this.form.country === '其他'){
            this.countryState = false
          }else {
            this.countryState = true
          }
      },

      /*点击确认添加*/
      confirmAddition(){
          this.verificationMsg(this.form,addAddress,this.selectedOptions);
      },

      /*删除地址*/
      deleteData(row) {
        this.$confirm('此操作將永久删除該地址, 是否繼續?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll:false,
          type: 'warning'
        }).then(() => {
          deleteAddress(row.id).then(res =>{
            this.displayAddress();
            this.$message.success('删除成功');
          })
        }).catch(() => {
          this.$message.info('已取消删除');
        });
      },

      /*验证信息*/
      verificationMsg(form,Address,selectedOptions){
        var reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
//        if(form.country === ''){
//          this.$message.warning('請選擇國家');
//        }else
        if(selectedOptions.length === 0){
          this.$message.warning('請選擇所在地區');
        }else if(!reg.test(form.consignee)){
          this.$message.warning('收貨人姓名必須為中文');
        }else if(!(this.telRg.test((form.tel).trim()))){
          this.$message.warning('請填寫正確的手機號碼');
        }
     /*   else if(!(this.emailRg.test((form.zip_code).trim())) && (form.zip_code).trim() != ''){
          this.$message.warning('請填寫正確的郵箱');
        }*/
        else {
          let loadingInstance = Loading.service({ fullscreen: true });
          Address(form).then(res =>{
            if (res){
              loadingInstance.close()
            }
            this.displayAddress()
            this.dialogFormVisible = false;
            this.$message.success('提交成功');
          }).catch(err =>{
            if (err){
              loadingInstance.close()
            }
          })
        }
      },


      /*获取收货地址*/
      displayAddress(){
        obtainAddress().then(res =>{
            this.addressData = res.data.data;
        })
      },

      /*设为默认地址*/
      defaultAddress(item){
        var def = {
          is_default:1,
          id:item.id
        };
        modifyAddress(def).then( res =>{
          this.$message.success('設定成功');
          this.displayAddress();
        })
      }
    },

    mounted(){
        this.displayAddress();
      window.scrollTo(0,0)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../../../css/receivingAddress.less";
</style>



// WEBPACK FOOTER //
// src/pages/personalPage/accountSettingPage/ReceivingAddress.vue